export default __webpack_public_path__ + "static/media/stuart-marshall-2015-contributions.83ba1449.png";